

(function ($) {
    "use strict";

    var romanMatrix = [
        [10, 'X'],
        [9, 'IX'],
        [5, 'V'],
        [4, 'IV'],
        [1, 'I']
    ];

    $.convertToRoman = function convertToRoman(num) {
        if (num === 0) {
            return '';
        }
        for (var i = 0; i < romanMatrix.length; i++) {
            if (num >= romanMatrix[i][0]) {
                return romanMatrix[i][1] + $.convertToRoman(num - romanMatrix[i][0]);
            }
        }
    }

    $.onlyUnique = function onlyUnique(value, index, self) {
        return self.indexOf(value) === index;
    }


    $(function () {



    });

})(jQuery);